export default "__VITE_ASSET__DtU4ABaJ__"